module.exports = __webpack_public_path__ + "static/scale-model-of-bakersfield-california-8e5cfae9cec5503ef68c148a19544bfd.png";